import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {SearchInputAreaBox} from "./boxes/search-input-area-box/search-input-area.box";
import {CyClass} from '../../../../../common/cy-classes';

export const SearchInputArea = observer(class SearchInputArea extends OrbitComponent<{}> {

  private _timeoutRef = null;
  private readonly HIDE_KEYBOARD_DELAY_MS: number = 2000;

  private _onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.services.gameSearch.search(event.target.value);
  }

  private _onChangeHandlerWithBlur = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.services.gameSearch.search(event.target.value);

    if (this._timeoutRef) {
      clearTimeout(this._timeoutRef);
    }

    this._timeoutRef = setTimeout(() => {
      this._timeoutRef = null;
      if (this.services.gameSearch.currentSearchText) {
        this.services.gameSearch.searchInputRef.current?.blur();
      }
    }, this.HIDE_KEYBOARD_DELAY_MS);
  };

  private _onClickHandler = () => {
      this.services.gameSearch.openSearchResult();
  };

  render() {

    const onChangeHandler = this.services.device.isMobile ? this._onChangeHandlerWithBlur : this._onChangeHandler;

    return (
      <SearchInputAreaBox
              ref={this.services.gameSearch.searchInputRef}
              className={CyClass('cy-game-search-input')}
              type={'text'}
              value={this.services.gameSearch.currentSearchText}
              autoComplete={'off'}
              placeholder={this.services.translation.translate('SEARCH_YOUR_GAME')}
              onChange={onChangeHandler}
              onClick={this._onClickHandler}/>
    );
  }
});
